module.exports = __webpack_public_path__ + "img/front exposed 10mm zipper length.ada61910.png";